$(document).ready(function () {

  // -- Accordion OLD  ------------------------------------------------ //
  (function ($) {
    $('.accordion a').click(function (j) {
      var dropDown = $(this).closest('li').find('.content');
      $(this).closest('.accordion').find('.content').not(dropDown).slideUp();
      if ($(this).hasClass('active')) {
        $(this).removeClass('active');
      } else {
        $(this).closest('.accordion').find('a.active').removeClass('active');
        $(this).addClass('active');
      }
      dropDown.stop(true, true).slideToggle();
    });
    $('.accordion-mobile .header-title').click(function (e) {
      $(this).next('.details').slideToggle("slow");
      $(this).toggleClass('active');
    });
  })(jQuery);

  $('.toggle').click(function (e) {
    e.preventDefault();
    var $this = $(this);
    if ($this.next().hasClass('show')) {
      $this.next().removeClass('show');
      $this.toggleClass('active'); 
      $this.next().slideUp(350);
    } else {
      $this.parent().parent().find('div .inner').removeClass('show');
      $this.parent().parent().find('div .toggle').removeClass('active');
      $this.parent().parent().find('div .inner').slideUp(350);
      $this.next().toggleClass('show');
      $this.toggleClass('active');
      $this.next().slideToggle(350);
    }
  });

  // -- Accordion FAQ  ------------------------------------------------ //
  $(function () {
    $('.accordion-faq h3').click(function (j) {
      var dropDown = $(this).closest('.item-faq').find('.subitens-faq');
      $(this).closest('.accordion-faq').find('.subitens-faq').not(dropDown).slideUp();
      if ($(this).hasClass('active')) {
        $(this).removeClass('active');
      } else {
        $(this).closest('.accordion-faq').find('.active').removeClass('active');
        $(this).addClass('active');
      }
      dropDown.stop(true, true).slideToggle();
    });
    $('.subitens-faq h4').click(function (j) {
      var dropDown = $(this).closest('.subitem-faq').find('.answer');
      $(this).closest('.subitens-faq').find('.answer').not(dropDown).slideUp();
      if ($(this).hasClass('active')) {
        $(this).removeClass('active');
      } else {
        $(this).closest('.subitens-faq').find('.active').removeClass('active');
        $(this).addClass('active');
      }
      dropDown.stop(true, true).slideToggle();
    });
  });

  // -- Modal -------------------------------------------------------- //
  var player_modal_instace = null;
  $(document).on('click', '.js-open-modal', function (e) {
    e.preventDefault();
    var target = $(this).data('target');
    var video = $(target).find('.js-video-modal');
    $(target).addClass('active');
    if (video.length > 0 && video.data('video-modal-autoplay') == "1") {
      player_modal_instace = new Plyr(video);
      player_modal_instace.on('ready', function (event) {
        player_modal_instace.play();
      });
    }
    $('body').addClass('modal-open');
  });

  $(document).on('click', '.js-close-modal', function (e) {
    e.preventDefault();
    var target = $(this).parents('.js-base-modal');
    closeModal(target);
  });

  $('.js-base-modal').click(function (e) {
    if (!($(e.target).hasClass('js-base-modal-content') || $(e.target).parents('.js-base-modal-content').length > 0)) {
      closeModal($(this));
    }
  });

  function closeModal(target) {
    var video = $(target).find('.plyr');
    if (video.length > 0) {
      player_modal_instace.pause();
    }
    $(target).removeClass('active');
    $('body').removeClass('modal-open');
  }

  var KEYCODE_ESC = 27;

  $(document).keyup(function (e) {
    if (e.keyCode == KEYCODE_ESC) {
      if ($('.js-base-modal.active').length > 0) {
        closeModal($('.js-base-modal.active'));
        // $('.js-base-modal.active').removeClass('active');
        // $('body').removeClass('modal-open');
      }
    }
  });

  // ----  Sticky Sidebar -------------------------------------------------- //
  // $(function () {
  //   var header = $("#header");
  //   $(window).scroll(function () {
  //     var scroll = $(window).scrollTop();
  //     if (scroll > 0) {
  //       header.addClass("sticky");
  //     } else {
  //       header.removeClass("sticky");
  //     }
  //   });
  // });

  // ----  Menu -------------------------------------------------- //

  if ( $(window).width() < 992 ) {
    $('.menu-mobile').click(function (e) {
      e.preventDefault();
      $(this).toggleClass('open');
      $('.menu-container').toggleClass('active');
      $('body').toggleClass('menu-active');
      $('.header').toggleClass('header-active');
      if(!sessionStorage['bannerApp']){
        if($('body').hasClass("menu-active")){
          $('.banner-app').hide();
        }else{
          $('.banner-app').show();
        }
      }
    });
    $('.close-menu').click(function (e) {
      e.preventDefault();
      $('.menu-container').removeClass('active');
      $('body').removeClass('menu-active');
      $('.header').removeClass('header-active');
    });

    $('#footer-menu li.menu-item-has-children > a').click(function (e) {
      e.preventDefault();
      $(this).parent().toggleClass('active-submenu');
      $('body').toggleClass('footer-active');
    });

    if ($(window).width() < 992) {
      jQuery(document).ready(function($) {
        $('#primary-menu > .menu-item-has-children').append('<span class="closed"></span');
      
        $("#primary-menu > .menu-item-has-children .closed").click(function() {
          var $parent = $(this).parents("#primary-menu .menu-item-has-children");
          var isActive = $parent.hasClass("active");
      
          $("#primary-menu .menu-item-has-children.active, #primary-menu > .menu-item-has-children .closed.active").removeClass("active");
          
          if (!isActive) {
            $parent.addClass("active");
            $(this).addClass("active");
            $("#primary-menu .menu-item-has-children .sub-menu").hide().removeClass("active");
            $("#primary-menu .menu-item-has-children .sub-menu li .sub-menu").show();
            $parent.children(".sub-menu").show().addClass("active");
            $parent.parents("#primary-menu .menu-item-has-children").addClass("active");
          } else {
            $parent.find(".sub-menu").css("display", "");
          }
        });
      });
    }
  }
  
  $('.back-item').click(function (e) {
    e.preventDefault();
    $('.drop-financiamento, .drop-financiamento-cn, .drop-consorcio, .drop-locadora, .drop-seguros-servicos').removeClass('active');
    $('.sub-menu:first').addClass('active');
  });

  if ($(window).width() > 992) {
    $('.drop-link-financiamento > a').click(function (e) {
      e.preventDefault();
      $('.sub-menu').removeClass('active');
      $('.drop-financiamento').addClass('active');
    });
    $('.drop-link-financiamento-cn > a').click(function (e) {
      e.preventDefault();
      $('.sub-menu').removeClass('active');
      $('.drop-financiamento-cn').addClass('active');
    });
    $('.drop-link-consorcio > a').click(function (e) {
      e.preventDefault();
      $('.sub-menu').removeClass('active');
      $('.drop-consorcio').addClass('active');
    });
    $('.drop-link-locadora > a').click(function (e) {
      e.preventDefault();
      $('.sub-menu').removeClass('active');
      $('.drop-locadora').addClass('active');
    });
    $('.drop-link-seguros-servicos > a').click(function (e) {
      e.preventDefault();
      $('.sub-menu').removeClass('active');
      $('.drop-seguros-servicos').addClass('active');
    });
  
    $('.back-item').click(function (e) {
      e.preventDefault();
      $('.drop-financiamento, .drop-financiamento-cn, .drop-consorcio, .drop-locadora, .drop-seguros-servicos').removeClass('active');
    });
  
    $('.menu-item-has-children').hover(
      function () {
        $('.drop-financiamento, .drop-financiamento-cn, .drop-consorcio, .drop-locadora, .drop-seguros-servicos').removeClass('active');
      },
      function () {
      }
    );
  }

  // ----  Slider -------------------------------------------------- //
  $('.sliderHome').slick({
    dots: false,
    infinite: true,
    loop: true,
    speed: 500,
    fade: true,
    arrows: true,
    cssEase: 'linear',
    autoplay: true,
    autoplaySpeed: 5000,
    responsive: [{
      breakpoint: 768,
      settings: {
        arrows: false,
        dots: true
      }
    }]
  });
  $('.sliderCardsHome').slick({ 
    infinite: true,
    speed: 500,
    arrows: true,
    autoplaySpeed: 5000,
    slidesToShow: 4,
    responsive:[{
      breakpoint:768,
      settings:
      {
        slidesToShow: 1,
        dots: true,
        arrows: false
      }
    }]
  });
  $('.sliderInvista').slick({
    dots: true,
    infinite: true,
    loop: true,
    speed: 500,
    fade: true,
    arrows: false,
    cssEase: 'linear',
    autoplay: true,
    autoplaySpeed: 5000
  });
  $('.sliderTimeline, .sliderVantagens').slick({
    dots: false,
    infinite: false,
    arrows: true,
    mobileFirst: true,
    responsive: [{
      breakpoint: 768,
      settings: "unslick"
    }]
  });
  $('.sliderCDB').slick({
    dots: false,
    infinite: true,
    speed: 500,
    fade: true,
    arrows: true,
    cssEase: 'linear',
    autoplay: true,
    autoplaySpeed: 5000,
    responsive: [{
      breakpoint: 768,
      settings: {
        arrows: false,
        dots: true
      }
    }]
  });
  $('.sliderCards').slick({
    infinite: true,
    speed: 500,
    arrows: true,
    autoplaySpeed: 5000,
    slidesToShow: 3,
    responsive:[{
      breakpoint:768,
      settings:
      {
        slidesToShow: 1,
        dots: true,
        arrows: false
      }
    }]
  });
  $('.sliderCrediNissan').slick({
    dots: true,
    infinite: true,
    loop: true,
    speed: 500,
    fade: true,
    arrows: true,
    cssEase: 'linear',
    autoplay: true,
    autoplaySpeed: 5000,
    responsive: [{
      breakpoint: 768,
      settings: {
        arrows: false,
        dots: false,
      }
    }]
  });
  if ( $(window).width() < 1024 ) {
    $('.sliderProducts').slick({
      dots: true,
      infinite: true,
      speed: 500,
      arrows: false,
      autoplaySpeed: 5000,
      slidesToShow: 1,
    });
  }
  else {
    $('.sliderProducts').slick('unslick');
  }
  if ( $(window).width() < 1024 ) {
    $('.sliderFAQ').slick({
      dots: true,
      infinite: true,
      speed: 500,
      arrows: false,
      autoplaySpeed: 5000,
      slidesToShow: 1,
    });
  }
  else {
    $('.sliderFAQ').slick('unslick');
  }
  if ( $(window).width() < 1024 ) {
    $('.sliderCardsProduct').slick({
      dots: true,
      infinite: true,
      speed: 500,
      arrows: false,
      autoplaySpeed: 5000,
      slidesToShow: 1,
    });
  }
  else {
    $('.sliderCardsProduct').slick('unslick');
  }

  // ----  Tooltip -------------------------------------------------- //
  $('.tooltip').click(function () {
    $(this).toggleClass('active');
  });

  // ----  Tooltip Rendimento -------------------------------------------------- //
  if ( $(window).width() < 1024 ) {
    $('.income .text span').click(function () {
      if ($(this).closest('.income').hasClass('active')){
        $('.income').removeClass('active');
        } else {
        $('.income').removeClass('active');
        $(this).closest('.income').addClass('active');
      }
      $('body').addClass('popup-open');
      return false;
    });
  }
  else {
    $('.income .text span').hover(function () {
      if ($(this).closest('.income').hasClass('active')){
        $('.income').removeClass('active');
        $('.box-item').removeClass('active');
        } else {
        $('.income').removeClass('active');
        $('.box-item').removeClass('active');
        $(this).closest('.income').addClass('active');
        $(this).closest('.box-item').addClass('active');
      }
    });
  }
  $('.income .tooltip .button').click(function () {
    $('.income').removeClass('active');
    $('body').removeClass('popup-open');
    return false;
  });

  // -- Smooth Scroll  ------------------------------------------------ //
  jQuery(document).ready(function () {
    jQuery('.scroll').click(function () {
      var target = jQuery(this).attr('href').split('#').pop();
      jQuery('html, body, index').animate({ scrollTop: jQuery('#' + target).offset().top }, 1000);
      return false;
    });
  });

  // -- Masked Input  ------------------------------------------------ //
  $(function () {
    $.mask.definitions['~'] = "[+-]";
    $("#telefone").mask("(99) 99999-9999", { autoclear: false });
  });

  // -- Timeline  ------------------------------------------------ //
  if (window.location.href.indexOf("historia") > 0) {
    function isVisible(elem) {
      return $(elem).offset().top - $(window).scrollTop() < $(elem).height();
    }
    $(function () {
      $(window).scroll(function () {
        var scroll = $(window).scrollTop();
        var windowCenter = $(window).height() / 2;
        var redProgressInit = $('.red-progress span').offset().top;
        var progressHeight = Math.round(scroll + windowCenter - redProgressInit);

        icons = $('.sliderTimeline li .progress i.icon')
        $.each(icons, function(k,i){
            icon = $(i);
            var iconTop = icon.offset().top;
              if (scroll + windowCenter > iconTop) {
                icon.parent().addClass('active');
              } else {
                icon.parent().removeClass('active');
              }
        })

        // var icons = [$('.ic0'), $('.ic1'), $('.ic2'), $('.ic3'), $('.ic4'), $('.ic5'), $('.ic6'), $('.ic7'), $('.ic8'), $('.ic9'), $('.ic10'), $('.ic11'), $('.ic12'), $('.ic13'), $('.ic14'), $('.ic15'), $('.ic16'), $('.ic17'), $('.ic18')];
        //
        // $.each(icons, function (k, icon) {
        //   var iconTop = icon.offset().top;
        //
        //   if (scroll + windowCenter > iconTop) {
        //     icon.parent().addClass('active');
        //   } else {
        //     icon.parent().removeClass('active');
        //   }
        // });

        if (scroll + windowCenter > redProgressInit) {
          progressHeight <= $('#timeline').height() && $('.red-progress span').height(progressHeight);
        }

        // Round progress initial
        if (scroll + windowCenter < redProgressInit) {
          $('.red-progress span').height(0);
        }

        // Round progress final
        if (progressHeight >= $('#timeline').height()) {
          $('.red-progress span').height($('#timeline').height());
        }
      });
    });
  }

  // -- Contact Form Submission  ------------------------------------------------ //
  document.addEventListener('wpcf7mailsent', function (event) {
    var contactForm = $('.form-content');
    var responseForm = $('.form-response');
    contactForm.hide();
    responseForm.show();
  }, false);

  $('.js-back').click(function () {
    location.reload();
  });
  $('#next-step').click(function() {
    $('.step-form-1').removeClass('active');
    $('.step-form-2').addClass('active');
    return false;
  });
  $('#previous-step').click(function() {
    $('.step-form-2').removeClass('active');
    $('.step-form-1').addClass('active');
    $('.wpcf7-response-output').hide();
    return false;
  });
});

// -- Tabs  ------------------------------------------------ //
$(document).ready(function () {
  $('ul.tabs li').click(function () {
    var tab_id = $(this).attr('data-tab');
    $('ul.tabs li').removeClass('current');
    $('.tab-content').removeClass('current');
    $(this).addClass('current');
    $("#" + tab_id).addClass('current');

    var offset = $("#" + tab_id).offset().top - 180;
    $("html, body").animate({ scrollTop: offset }, 300);
  });

  if (location.hash != "") {
    var initialTab = location.hash.replace("#", "");
    $("li[data-tab='" + initialTab + "']").click();
  }
});


// -- Tabs Rating  ------------------------------------------------ //
$(document).ready(function () {
  $('ul.tab-rating li').click(function () {
    var tab_id = $(this).attr('data-tab');
    $('ul.tab-rating li').removeClass('current');
    $('.tab-rating-content').removeClass('current');
    $(this).addClass('current');
    $("#" + tab_id).addClass('current');
  });
});

// -- Banner app  ------------------------------------------------ //
$(document).ready(function () {
  var iphone = "https://itunes.apple.com/us/app/cdb-banco-rci/id1453421003?l=pt&ls=1&mt=8";
  var android = "https://play.google.com/store/apps/details?id=com.snowmanlabs.rci.rciinvestidor";
  $('.link-app').attr("href", /iPhone/.test(navigator.userAgent)?iphone:android);

  if(!sessionStorage['bannerApp'] && $(window).width() < 992){
    $('.banner-app').show();
  }
  $('.close-banner').click(function (e) {
    e.preventDefault();
    sessionStorage['bannerApp'] = true;
    $('.banner-app').hide();
  }); 
});

// -- Select year  ------------------------------------------------ //
$(function() {
  $('#year-select').change(function() {
    var id = $(this).val();
    $('.download-item').removeClass("toggle-show");
    $('#year_' + id).addClass("toggle-show");
  }).change();
});

$( document ).ready(function() {
  mobileOnlySlider(".app-screen", 767);
  function mobileOnlySlider($slidername, $breakpoint) {
    var slider = $($slidername);
    var settings = {
      mobileFirst: true,
      dots: false,
      arrows: false,
      slidesToShow: 1,
      infinite: false,
      autoplay: true,
      autoplaySpeed: 3000,
      responsive: [
        {
          breakpoint: $breakpoint,
          settings: "unslick"
        }
      ]
    };
    slider.slick(settings);
    $(window).on("resize", function () {
      if ($(window).width() > $breakpoint) {
        return;
      }
      if (!slider.hasClass("slick-initialized")) {
        return slider.slick(settings);
      }
    });
  }
  if ( $(window).width() > 767 ) {
    $(".app-screen").hover(
    function() {
      $(".app-item", this).hover(function() {
        $(this).closest(".app-screen").find('.app-item').removeClass('hoverin').addClass('hoverout')
        $(this).addClass('hoverin').removeClass('hoverout')
      }, function() {
        $(this).removeClass('hoverin').addClass('hoverout')
      });
    }, function() {
      $(".app-item", this).removeClass("hoverout hoverin")
    })
  }
});

// -- Header - Nav  ------------------------------------------------ //
$(document).ready(function() {
  if ($(window).width() > 992) {
    var maxHeight = 0;
    var totalHeight1, totalHeight2;

    $('.sub-menu').each(function() {
      var height = $(this).height();
      if (height > maxHeight) {
        maxHeight = height;
      }
    });

    var headerHeight = $('header').height();
    if ($('header').hasClass('header')) {
      headerHeight += 60;
    }
    
    totalHeight1 = maxHeight + headerHeight - 90;

    var dropFinanciamentoCnHeight = $('.drop-financiamento-cn').height();
    var subMenuHeight = $('.sub-menu').height();

    totalHeight2 = dropFinanciamentoCnHeight > subMenuHeight ? dropFinanciamentoCnHeight : maxHeight + headerHeight;
    totalHeight2 += $('#headerCrediNissan').height();
    totalHeight2 += 40;

    $('#header .menu-item-has-children a').hover(function() {
      $('#header').css('height', totalHeight1 + 'px');
    });

    $('#headerCrediNissan .menu-item-has-children a').hover(function() {
      $('#headerCrediNissan').css('height', totalHeight2 + 'px');
      $(this).next('.sub-menu').addClass('active');
    });

    $('.header .menu-item-has-children a').hover(function() {
      if (!$(this).closest('.sub-menu').length) {
        $('.sub-menu').not($(this).next('.sub-menu')).removeClass('active');
        $(this).next('.sub-menu').addClass('active');
      }
    });

    $('#headerCrediNissan .menu-item a').hover(function () {
      $(this).closest('.menu-item').siblings('.menu-item').find('.sub-menu').removeClass('active');
    });

    $('header').mouseleave(function() {
      $(this).css('height', 'auto');
      $('.sub-menu').removeClass('active');
      $('.drop-financiamento, .drop-financiamento-cn, .drop-consorcio, .drop-seguros-servicos').removeClass('active');
    });

    $('#headerCrediNissan .menu-item:not(.menu-item-has-children) a').hover(function() {
      if (!$(this).parents('.sub-menu').length) {
        $('header').css('height', 'auto');
      }
    });
  }
});

// -- Credi Nissan - Financiamento - Planos  ------------------------------------------------ //
$(document).ready(function() {
  var tabDiv = $(".tab-content > div");
  var buttons = $(".button-content button");

  buttons.first().click(function() {
      tabDiv.add(buttons).removeClass("active");
      tabDiv.addClass("active");
      buttons.first().addClass("active");
  });

  buttons.last().click(function() {
      buttons.first().removeClass("active");
      $(this).addClass("active");
      tabDiv.removeClass("active");
  });
});

// -- Credi Nissan - Financiamento - NDV  ------------------------------------------------ //
$(document).ready(function () {
  $(".heading-item").click(function () {
      var headingItem = $(this);
      var infoItem = headingItem.next(".info-item");

      $(".heading-item").not(headingItem).removeClass("active");
      $(".info-item").not(infoItem).removeClass("active");

      headingItem.toggleClass("active");
      infoItem.toggleClass("active");
  });
});